import React from 'react';
import { directionMap, GenericIconProps } from './utils';
import theme from '../utils/theme/theme';

export default function IconChevron(props: GenericIconProps) {
  const {
    width = 6,
    height = 10,
    stroke = theme.colors.primary,
    direction = 'left',
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      version="1.1"
      style={{
        transform: `rotate(${directionMap[direction]}deg)`,
        transition: 'transform 0.2s',
      }}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinejoin="round"
      >
        <g
          transform="translate(-191.000000, -216.000000)"
          stroke={stroke}
          strokeWidth="2"
        >
          <g transform="translate(182.000000, 209.000000)">
            <polyline points="14 16 10 12 14 8" />
          </g>
        </g>
      </g>
    </svg>
  );
}
